import { getTimeFromUTCCore } from './chunk-RO5AAHK3.mjs';
import { getIsItemHiddenCore } from './chunk-MFMTSPFX.mjs';
import _capitalize from 'lodash/capitalize';
import sortBy from 'lodash/sortBy';

var employeesArrayFactoryCore = (users, state) => {
  const employees = Object.values(users).map((user) => {
    var _a;
    if (user.user)
      return {
        name: `${user.user.firstName} ${user.user.lastName}`,
        role: _capitalize((_a = user.shiftTimeSummary.role) == null ? void 0 : _a.name) || "- - -",
        clock_in_time: getTimeFromUTCCore(
          user.shiftTimeSummary.clockInTime,
          state
        ),
        status: user.shiftTimeSummary.status
      };
    else
      return null;
  }).filter(
    (user) => user !== null && user.status !== "inactive"
  );
  return employees;
};
var isShowedInRegisterCore = (item, state) => {
  const { menuTypes, categories, subcategories } = state.menu.selectedMode.currentMenu;
  const noHiddenMenuTypeVersions = Object.values(item.menuTypeVersions).filter(
    (menuTypeVersion) => {
      var _a;
      return (_a = menuTypes[menuTypeVersion.menuTypeId]) == null ? void 0 : _a.active;
    }
  );
  const isItemHidden = getIsItemHiddenCore(
    item.menuTypeVersions,
    categories,
    subcategories,
    "items",
    item.itemId,
    menuTypes
  );
  const isItemActive = noHiddenMenuTypeVersions.some(
    (menuTypeVersion) => menuTypeVersion == null ? void 0 : menuTypeVersion.active
  );
  if (isItemHidden || !noHiddenMenuTypeVersions.length || !isItemActive) {
    return false;
  }
  return true;
};
var freshSheetArrayFactoryCore = (items, state) => {
  const _items = Object.values(items).reduce(
    (acc, item) => {
      if (!item)
        return acc;
      const itemMenuTypeVersions = Object.values(item.menuTypeVersions);
      const menuTypeVersionData = itemMenuTypeVersions[0];
      if (!isShowedInRegisterCore(item, state) || !menuTypeVersionData.showOnFreshSheet) {
        return acc;
      }
      return [
        ...acc,
        {
          id: item.itemId,
          currentAmount: menuTypeVersionData.currentAmount,
          name: item.name,
          is86ed: menuTypeVersionData.is86ed,
          freshSheetSortPriority: menuTypeVersionData.freshSheetSortPriority
        }
      ];
    },
    []
  );
  return sortBy(_items, ["freshSheetSortPriority"]);
};

export { employeesArrayFactoryCore, freshSheetArrayFactoryCore, isShowedInRegisterCore };
